module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-valors-innovation.cc221257.svg";